import { createEnumParam } from 'use-query-params';

export const TwoPlayerParam = createEnumParam(['any', 'no', 'only']);
